import {createApp} from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import store from './store'
import ru from 'element-plus/dist/locale/ru'
import interceptors from '@/utils/interceptors'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

interceptors();

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(ElementPlus, {locale: ru}).use(store).use(router).mount('#app');